import { render } from "./ObjectAddScratch.vue?vue&type=template&id=72394f20"
import script from "./ObjectAddScratch.vue?vue&type=script&lang=js"
export * from "./ObjectAddScratch.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__